import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { SocietyDetails } from 'src/app/classes/society';
import { BylawsService } from 'src/app/services/bylaws.service';
import { Page } from 'src/app/classes/page';
import { ToastService } from 'src/app/toast/toast.service';
import jsPDF from 'jspdf';
import { DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import html2canvas from 'html2canvas';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Modal } from 'bootstrap';
import { EncryptionService } from 'src/app/services/encryption.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/auth/config.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaymentService } from 'src/app/services/payment.service';
import { SweetAlertService } from 'src/app/toast/sweet-alert.service';
import Swal from 'sweetalert2';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-bylaws',
  templateUrl: './bylaws.component.html',
  styleUrls: ['./bylaws.component.scss']
})
export class BylawsComponent implements OnInit, AfterViewInit {
  AmendmentsList: any;
  //   data:any = {
  //   regNo: 'HPCD-4809',
  //   oldName: 'HIM ANCHAL EDUCATIONAL SOCIETY',
  //   newName: 'SARV JAN KALYAN SABHA',
  //   address: 'C/O G.R. SHARMA, VILLAGE PATYAHU, P.O. NALTI, TEHSIL AND DISTRICT HAMIRPUR H.P- 177001',
  //   district: 'SHIMLA',
  //   regDate: '31/03/2021',
  //   amendDate: '04/05/2024'
  // };
  // data = {
  //   societyName: 'The Chinmaya Tapovan Trust',
  //   address: 'VPO Sidhbari District Kangra',
  //   district: 'SHIMLA',
  //   regNo: '376/77',
  //   regDate: '24/03/1977',
  //   amendDate: '13/03/2026',
  //   amendDayText: '13th day of March 2026'
  // };
  data = {
    societyName: 'New Creation Fellowship',
    oldAddress: 'C/O Kesar Mani VPO Tapri Sub Tehsil Tapri Distt. Kinnaur HP 172104',
    newAddress: 'C/O THOBAL NIWAS BHABANAGAR NEAR BSNL TOWER BHABANAGAR, DISTRICT KINNAUR, HP 172115',
    district: 'SHIMLA',
    regNo: 'HPCD-637',
    regDate: '14/01/2019',
    amendDate: '29/01/2021',
    amendDayText: '29th day of January 2021'
  };
  // type:any='name'
  type: any = 'Address'
  applicationModel = 1;
  bylawsProgress: any[] = [];
  updateStatusForm!: FormGroup;
  remarkList: any;
  checkboxOptions: any[] = [
    { id: 1, label: "It is not contrary to the provisions of this Act and the Rules." },
    { id: 2, label: "It does not conflict with Co-operative principles." },
    { id: 3, label: "It will promote the economic or social interest of the members of the society." },
    { id: 4, label: "It is not inconsistent with the principles of social justice." }

  ];
  selectedRemarkDetails: any;
  roles: any[] = [];

  selected: any[] = []
  @ViewChild('amendmentDetailsRef') amendmentDetailsRef!: TemplateRef<any>;
  @ViewChild('amendmentsDetailTable') amendmentsDetailTable?: DatatableComponent;
  societyDetails: any
  societyregistration: any = null
  displayedColumns: string[] = ['#', 'Date', 'TotalAmmendments', 'AmmendmentsToAdded', 'AmmendmentsToChange', 'AmmendmentsToRemove', 'Status', 'Action'];
  page = new Page();
  aplicationDetailList: any;
  ExpendeText = '';
  orderColumns: any = [
    { prop: 'id', name: "id", width: 50, sorting: true },
    { prop: 'sByLawsNo', name: 'ByLaws Number', width: 100 },
    { prop: 'sNewByLawsDetail', name: 'byLaws', align: { head: 'center' } },

  ];
  OrderCertiftcateData: any = {
    bylaws: [],
    societyName: '',
    societyAddress: '',
    societyRegistrationNo: '',
    approvedate: ''
  };
  societyId: any;
  constructor(
    private alertService: SweetAlertService,
    private paymentService: PaymentService,
    private byLawsService: BylawsService, private route: ActivatedRoute, private configService: ConfigService,
    private encryptionService: EncryptionService, private router: Router, private toastService: ToastService, private fb: FormBuilder,
    private ngxUiLoaderService: NgxUiLoaderService, private authService: AuthService) {
    this.page.pageNumber = 0;
    this.page.pageSize = 10;
    this.page.totalRecords = 0;

  }


  columns = [
    { name: '#', prop: 'index', sortable: false },
    { name: 'Date', prop: 'Date', sortable: true },
    { name: 'Total Amendments', prop: 'TotalAmmendments', sortable: true },
    { name: 'Amendments To Add', prop: 'AmmendmentsToAdded', sortable: true },
    { name: 'Amendments To Change', prop: 'AmmendmentsToChange', sortable: true },
    { name: 'Amendments To Remove', prop: 'AmmendmentsToRemove', sortable: true },
    { name: 'Status', prop: 'sAuditStatus', sortable: true },
    { name: 'Action', prop: 'Action', sortable: false }
  ];

  currentUser: any
  SelectionType = SelectionType;

  ngOnInit(): void {
    let user: any = this.authService.currentUserValue
    this.currentUser = user


    this.route.queryParams.subscribe(params => {
      const status = params['status'];
      const txn = params['txn'];

      if (params && status) {
        if (status === 'success') {

          this.alertService.successAlert(
            'Payment Successful ✅',
            `Your payment was completed successfully.\nTransaction ID: ${txn}`,
            //  'Continue'
          );


        } else {
          this.alertService.confirmAlert(
            'Payment Failed ❌',

            `Your payment could not be processed. Please try again. \nTransaction ID: ${txn}`,
            'Retry',
            'Cancel'
          );
        }
      }

    });
    if (this.currentUser.roleId != 9) {
      this.router.navigate(['bylaws/NewAmendments'])
    }
    this.societyregistration = this.currentUser?.registrationNo;
    let society: any = sessionStorage.getItem('societyDetail');
    this.societyDetails = JSON.parse(society);
    if (this.societyDetails) {
      this.getAmendmentsList(this.societyDetails?.iSocietyDetailsId);
    }
    this.setPage({ offset: 0 });

    this.updateStatusForm = this.fb.group({
      role: [''],
      statusFile: [''],
      status: ['', Validators.required],
      remark: ['', Validators.required],
      // checkboxes: this.fb.array([], [this.allCheckboxesRequired()])

    })
    this.updateStatusForm.controls['remark'].disable()
    this.updateStatusForm.controls['statusFile'].disable()
    this.updateStatusForm.controls['status'].disable()

    this.getAmendmentType()
  }

  succssAlert() {


  }

  ngAfterViewInit(): void {

  }
  AmendmentType: any
  setPage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;


  }
  getAmendmentType(): void {
    this.byLawsService.Amendsmenttypes().subscribe({
      next: (response: any) => {
        if (response.status === 200) {

          this.AmendmentType = response.data;

        }
      },
      error: (err) => {
        console.error('Failed to fetch amendment types', err);
      }
    });
  }
  typeName(id: any) {
    return this.AmendmentType?.find((a: any) => a.id == id)?.name ?? '';
  }
  approveLastAmendment: boolean = true
  getAmendmentsList(societyID: any) {
    let obj = {
      iSocietyDetailsId: societyID
    }
    this.ngxUiLoaderService.start();

    if (this.societyDetails.iSocietyId == 1) {
      this.byLawsService.getAmmendmentList2006(obj, '').subscribe((res: any) => {
        this.ngxUiLoaderService.stop();
        if (res?.status == 200 && res?.data && res?.data.length) {
          this.AmendmentsList = res?.data;
          // this.AmendmentsList = this.combinedata(this.AmendmentsList)



          this.approveLastAmendment = ((this.AmendmentsList[0]?.IsPaid == 1 || this.AmendmentsList[0]?.sAuditStatus == "Rejected" || this.AmendmentsList[0]?.sAuditStatus == "Approved" )&& this.AmendmentsList[0]?.sAmendmentCertificate  != null) ? true : false;
          this.columns.push({ name: 'Fee', prop: 'FeeAmount', sortable: true })
        } else {
          this.AmendmentsList = [];
          this.approveLastAmendment = true;
          this.toastService.showInfo(res?.message)
        }

      }, (res) => {
        this.ngxUiLoaderService.stop();
        if (res.status != 200) {

          this.toastService.showError(res?.message)
        }
      })
    } else {
      this.byLawsService.getAmmendmentList(obj, '').subscribe((res: any) => {
        this.ngxUiLoaderService.stop();
        if (res?.status == 200 && res?.data && res?.data.length) {
          this.AmendmentsList = res?.data;

          this.approveLastAmendment = (this.AmendmentsList[0]?.sAuditStatus == "Approved" || this.AmendmentsList[0]?.sAuditStatus == "Rejected") ? true : false;
        } else {
          this.AmendmentsList = [];
          this.approveLastAmendment = true;
          this.toastService.showInfo(res?.message)
        }

      }, (res) => {
        this.ngxUiLoaderService.stop();
        if (res.status != 200) {

          this.toastService.showError(res?.message)
        }
      })
    }


  }

  combinedata(data: any) {
    return Object.values(
      data.reduce((acc: any, item: any) => {
        const id = item.iByLawsId;

        if (!acc[id]) {
          acc[id] = {
            iByLawsId: id,
            existingDetails: [],
            newByLawsDetails: [],
            reasons: []
          };
        }

        // ✅ ExistingDetail (split by |)
        if (item.ExistingDetail) {
          const existing = item.ExistingDetail
            .split('|')
            .map((x: string) => x.trim())
            .filter((x: string) => x);

          acc[id].existingDetails.push(...existing);
        }

        // ✅ NewByLawsDetail (split by |)
        if (item.NewByLawsDetail) {
          const newDetails = item.NewByLawsDetail
            .split('|')
            .map((x: string) => x.trim())
            .filter((x: string) => x);

          acc[id].newByLawsDetails.push(...newDetails);
        }

        // ✅ Reason
        if (item.Reason) {
          acc[id].reasons.push(item.Reason);
        }

        return acc;
      }, {})


    );
  }
  getByLawsOrderCertificate(data: any) {
    let action = ''
    if (this.societyDetails.iSocietyId == 1) {
      action = 'ByLawsOrderCertificate2006'
    } else {
      action = 'ByLawsOrderCertificate'
    }
    this.ngxUiLoaderService.start();
    this.byLawsService.getByLawsOrderCertificate(this.societyDetails?.iSocietyDetailsId, data?.iByLawsId, action).subscribe((res: any) => {
      this.ngxUiLoaderService.stop();
      if (res?.status == 200 && res?.data && res?.data.length > 0) {
        if (this.societyDetails.iSocietyId == 1) {

          this.certificateList = this.buildCertificates(res?.data[0])


          this.openModal('certificateDetails')
        } else {

          this.OrderCertiftcateData.bylaws = JSON.parse(res?.data[0]?.ByLawsDetails);
          this.OrderCertiftcateData.societyRegistrationNo = res?.data[0]?.sSocietyRegistrationNo;
          this.OrderCertiftcateData.societyName = res?.data[0]?.sSocietyName;
          this.OrderCertiftcateData.approvedate = res?.data[0]?.ApprovedDate;
          let address = res?.data[0]?.sAddress1 + ", " + res?.data[0]?.sVillageName + ", " + res?.data[0]?.SBlockName + ", Tehsil & Distt. " + res?.data[0]?.SDistrictName + ", H.P ," + res?.data[0]?.sPincode
          this.OrderCertiftcateData.societyAddress = address;
          this.openModal('AmendmentsOrderDetails');
        }

      } else {
        this.OrderCertiftcateData = {
          bylaws: [],
          societyName: '',
          societyAddress: '',
          societyRegistrationNo: ''
        }
      }


    }, (res) => {
      this.ngxUiLoaderService.stop();
      if (res.status != 200) {

        this.toastService.showError('Something went wrong')
      }
    })
  }
  societyMemberList: any[] = [];
  filteredMembers: any[] = [];
  amendmentsList: any[] = [];
  bylawsList: any[] = [];
  uploadedFiles: any = {};
  Uploadedkeys: any[] = [];
  totalAmendmentCount: number = 0;
  buildCertificates(res: any) {
    let byLaws = [];

    try {
      byLaws = JSON.parse(res?.ByLawsDetails || '[]');
    } catch {
      byLaws = [];
    }

    const certificates: any[] = [];

    let bylawsList: any[] = [];

    byLaws.forEach((item: any) => {

      // ✅ NAME
      if (item.sAmmendmentType == '1') {
        certificates.push({
          type: 'NAME',
          label: 'Name Change Certificate',
          oldName: item.sExistByLawsDetail,
          newName: item.sNewByLawsDetail,
          societyName: res.sSocietyName,
          address: res.sAddress1,
          district: res.SDistrictName,
          regNo: res.sSocietyRegistrationNo,
          regDate: this.formatDate(res.ApprovedDate),
          amendDate: this.formatDate(res.ApprovedDate)
        });
      }

      // ✅ ADDRESS
      else if (item.sAmmendmentType == '5') {
        certificates.push({
          type: 'ADDRESS',
          label: 'Address Change Certificate',
          oldAddress: item.sExistByLawsDetail,
          newAddress: item.sNewByLawsDetail,
          societyName: res.sSocietyName,
          district: res.SDistrictName,
          regNo: res.sSocietyRegistrationNo,
          regDate: this.formatDate(res.ApprovedDate),
          amendDate: this.formatDate(res.ApprovedDate)
        });
      }

      // ✅ BYLAWS → COLLECT ONLY
      else {
        bylawsList.push({
          old: item.sExistByLawsDetail,
          new: item.sNewByLawsDetail
        });
      }

    });

    // ✅ ADD SINGLE BYLAWS CERTIFICATE
    if (bylawsList.length > 0) {
      certificates.push({
        type: 'BYLAWS',
        label: 'Bylaws Amendment Certificate',
        bylawsList: bylawsList, // 🔥 ALL DATA HERE

        societyName: res.sSocietyName,
        address: res.sAddress1,
        district: res.SDistrictName,
        regNo: res.sSocietyRegistrationNo,
        regDate: this.formatDate(res.ApprovedDate),
        amendDate: this.formatDate(res.ApprovedDate)
      });
    }

    return certificates;
  }
  // buildCertificates(res: any) {
  //   let byLaws = [];

  //   try {
  //     byLaws = JSON.parse(res?.ByLawsDetails || '[]');
  //   } catch {
  //     byLaws = [];
  //   }


  //   const certificates: any[] = [];

  //   byLaws.forEach((item: any) => {
  //     let type = '';

  //     if (item.sAmmendmentType == '5') type = 'ADDRESS';
  //     else if (item.sAmmendmentType == '1') type = 'NAME';
  //     else type = 'BYLAWS';

  //     certificates.push({
  //       type,
  //       label:
  //         type === 'ADDRESS'
  //           ? 'Address Change Certificate'
  //           : type === 'NAME'
  //           ? 'Name Change Certificate'
  //           : 'Bylaws Amendment Certificate',

  //       societyName: res?.sSocietyName,
  //       regNo: res?.sSocietyRegistrationNo,
  //       regDate: this.formatDate(res?.ApprovedDate),
  //       district: res?.SDistrictName,
  //       state: res?.sName,
  //       address: res?.sAddress1,

  //       oldValue: item?.sExistByLawsDetail,
  //       newValue: item?.sNewByLawsDetail
  //     });
  //   });

  //   return certificates;
  // }
  selectCertificate(cert: any) {

    this.selectedCertificate = cert;
    this.openModal('openCertificateDetails')
    this.showPopup = false;
  }
  certificateList: any[] = [];
  selectedCertificate: any = null;
  showPopup = false;
  disclamerOptions: any[] = [];
  disclamerOptionsBackup: any[] = [];
  getDisclaimer() {
    this.byLawsService.getDisclaimer().subscribe(res => {
      if (res?.data && res?.data.length > 0) {
        this.disclamerOptions = res.data;
        this.disclamerOptionsBackup = JSON.parse(JSON.stringify(res?.data))
      }


      //this.toastService.showSuccess(response.message);
    },
      (error: any) => {
        //this.toastService.showError(error.message);
      }
    );
  }
  openCertificatePopup(res: any) {
    this.certificateList = this.buildCertificates(res);
    this.showPopup = true;
  }
  formatDate(date: string) {
    if (!date) return '';
    const d = new Date(date);

    return d.toLocaleDateString('en-GB'); // 23/03/2026
  }
  closeOrder() {
    this.OrderCertiftcateData = {
      bylaws: [],
      societyName: '',
      societyAddress: '',
      societyRegistrationNo: ''
    }
  }
  groupedBylaws: any[] = [];

  groupByType() {

    const groups: any = {};

    // Only show detail sections for types still in "Amendments Proposed in"
    const allowedTypes = new Set(
      (this.amendmentsList || [])
        .map((a: any) => Number(a?.amendmentType ?? a?.value?.amendmentType))
        .filter((n: number) => !Number.isNaN(n))
    );

    const amendmentMap = new Map(
      (this.amendmentsList || []).map((a: any) => {
        const type = Number(a?.amendmentType ?? a?.value?.amendmentType);
        return [type, a?.value ?? a];
      })
    );

    (this.aplicationDetailList?.byLawsDetailsResponse || []).forEach((item: any) => {


      const rawKey = item?.sAmmendmentType ?? item?.sAmendmentType;

      const key = Number(rawKey);

      // Skip orphan details (e.g. Objectives deleted from registration but old detail still in API)
      if (allowedTypes.size > 0 && !allowedTypes.has(key)) {
        return;
      }

      const matchedAmendment = amendmentMap.get(key);

      if (!groups[key]) {
        groups[key] = {
          amendmentId: key,
          amendmentType: matchedAmendment?.amendmentType ?? key,
          bylaws: []
        };
      }

      groups[key].bylaws.push({
        amendmentType: matchedAmendment?.amendmentType ?? key,
        existingDetails: item?.sExistByLawsDetail || [],
        proposedChange: item?.sNewByLawsDetail || [],
        purposesChange: item?.reason || []
      });

    });

    this.groupedBylaws = Object.values(groups);

  }

  /** TASK: hide Proposed section when empty — undo if manager asks to revert */
  hasProposedContent(proposed: any): boolean {
    if (proposed == null || proposed === '') {
      return false;
    }
    if (Array.isArray(proposed)) {
      return proposed.some((p: any) => !!String(p ?? '').trim());
    }
    return !!String(proposed).trim();
  }

  groupHasProposed(group: any): boolean {
    return (group?.bylaws || []).some((item: any) =>
      this.hasProposedContent(item?.proposedChange)
    );
  }

  orderData = [];
  onSelect(selected: any) {

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected?.selected);
  }
  get filteredGoverningMembers() {
    const allowedIds = [14, 15, 16, 89, 125];

    return this.societyMemberList?.filter(item =>
      allowedIds.includes(item.iMemDesId)
    );
  }
  formatLabel(value: string): string {
    if (!value) return '';

    return value
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  }
  getApplicationDetail(data: any) {

    let obj = {
      iByLawsId: data?.iByLawsId,
      iByLawsDetailId: data?.iByLawsId
    }
  this.ngxUiLoaderService.start()
if (this.societyDetails.iSocietyId == 1){
      this.byLawsService.getApplicationDetails2006(obj).subscribe((res: any) => {

        if (res?.status == 200 && res?.data) {

          this.aplicationDetailList = res?.data;

          this.aplicationDetailList.selectedRow = data;

          this.societyMemberList = this.aplicationDetailList.memberList || [];

          this.filteredMembers = [...this.societyMemberList];

          this.amendmentsList = this.aplicationDetailList.amendments || [];

          this.bylawsList = (this.aplicationDetailList.byLawsDetailsResponse || []).map((item: any) => ({
            existingDetails: item.sExistByLawsDetail
              ? item.sExistByLawsDetail.split('\n')
              : [],

            proposedChange: item.sNewByLawsDetail
              ? item.sNewByLawsDetail.split('\n')
              : [],

            purposesChange: item.reason
              ? item.reason.split('\n')
              : []
          }));

          setTimeout(() => {
            this.groupByType();
          }, 1000);

          this.uploadedFiles = {
            FormIV: this.aplicationDetailList.sFormIVPath,
            comparativeChart: this.aplicationDetailList.sComparativeChartPath,
            AuditedAccountReturn: this.aplicationDetailList.sAuditedAccountReturnPath,
            GeneralBodyResolution: this.aplicationDetailList.sGeneralBodyResolutionPath,
            ExecutiveBodyResolution: this.aplicationDetailList.sExecutiveBodyResolutionPath
          };

          this.Uploadedkeys = Object.keys(this.uploadedFiles)
            .filter(key => this.uploadedFiles[key]);

          this.totalAmendmentCount = this.AmendmentsList
            .filter(
              (item: any) => item.iSocietyDetailsId === data.iSocietyDetailsId
            ).length;

          if (this.societyDetails.iSocietyId == 1) {

            this.getBindRoles('BindRoles2006');

            this.getbylawsProgressDetail(data, 'ByLawsProgress2006');

            this.getUserRemarks(data?.iByLawsId, 'GetRemark2006');

            this.openModal('AmendmentsAppDetails2006');

          } else {

            this.getBindRoles('BindRoles');

            this.getbylawsProgressDetail(data, 'ByLawsProgress');

            this.getUserRemarks(data?.iByLawsId, 'GetRemark');

            this.openModal('AmendmentsAppDetails');

            
          }
        }

        this.ngxUiLoaderService.stop();

      }, (res) => {

        this.ngxUiLoaderService.stop();

      });

      // if (data?.sAuditStatus == 'Pending') {
      //   this.verificatioProcess(data);
      // }
    } else {
      this.byLawsService.getApplicationDeatails(obj).subscribe((res: any) => {
        if (res?.status == 200 && res?.data) {
          this.aplicationDetailList = res?.data;
          this.aplicationDetailList.selectedRow = data;

          const finishOpen = (details: any[]) => {
            const normalized = (details || []).map((row: any) =>
              this.normalizeAmendmentDetailRow(row)
            );
            this.aplicationDetailList.byLawsDetails = normalized;
            this.aplicationDetailList.ByLawsDetails = normalized;
            this.getBindRoles('BindRoles');
            this.getbylawsProgressDetail(data, 'ByLawsProgress');
            this.getUserRemarks(data?.iByLawsId, 'GetRemark');
            this.openModal('AmendmentsAppDetails');
            // ngx-datatable inside a just-opened modal often renders with 0 body height
            setTimeout(() => {
              this.amendmentsDetailTable?.recalculate();
            }, 300);
            this.ngxUiLoaderService.stop();
          };

          const apiDetails = res?.data?.byLawsDetails || res?.data?.ByLawsDetails || [];

          // Always prefer GetByLaws for detail rows (AmmendmentDetails often returns empty)
          if (data?.iByLawsId) {
            this.byLawsService.getByLaws(data.iByLawsId).subscribe(
              (gRes: any) => {
                const gDetails =
                  gRes?.status == 200
                    ? gRes?.data?.byLawsDetails || gRes?.data?.ByLawsDetails || []
                    : [];
                finishOpen(gDetails.length ? gDetails : apiDetails);
              },
              () => finishOpen(apiDetails)
            );
            return;
          }

          finishOpen(apiDetails);
        } else {
          this.ngxUiLoaderService.stop();
        }
      }, () => {
        this.ngxUiLoaderService.stop();
      });
    }
  }

  /** Normalize action type fields so Add/Change/Remove render correctly in Application view. */
  normalizeAmendmentDetailRow(row: any): any {
    if (!row) {
      return row;
    }
    const actionType = Number(
      row.sAmmendmentType ??
        row.SAmmendmentType ??
        row.ammendmentType ??
        row.AmmendmentType ??
        row.amendmentType ??
        0
    );
    return {
      ...row,
      sAmmendmentType: actionType || row.sAmmendmentType,
      sAmmendmentTypeSubject:
        row.sAmmendmentTypeSubject ??
        row.SAmmendmentTypeSubject ??
        row.ammendmentTypeSubject,
      sByLawsNo: row.sByLawsNo ?? row.SByLawsNo ?? row.bylawsNumber,
      sNewByLawsDetail:
        row.sNewByLawsDetail ?? row.SNewByLawsDetail ?? row.newBylawsDetails,
      sExistByLawsDetail:
        row.sExistByLawsDetail ??
        row.SExistByLawsDetail ??
        row.existingBylawsDetails
    };
  }

  getAmendmentActionLabel(row: any): string {
    const t = Number(
      row?.sAmmendmentType ??
        row?.ammendmentType ??
        row?.AmmendmentType ??
        row?.amendmentType ??
        0
    );
    if (t === 1) {
      return 'Add';
    }
    if (t === 2) {
      return 'Change';
    }
    if (t === 3) {
      return 'Remove';
    }
    return 'NA';
  }
  verificatioProcess(data: any) {
    let obj = {
      "iByLawsId": data?.iByLawsId ? data?.iByLawsId : 0,
      "iSocietyDetailsId": data?.iSocietyDetailsId,
      "iRoleID": Number(this.currentUser?.roleId),
      "iUserID": 0,
      "action": (this.currentUser?.roleId == 11) ? 'ReviewApplicationBI' : (this.currentUser?.roleId == 12) ? 'ReviewApplicationDI' : 'ReviewApplicationAR'


    }
    if ([11, 13, 12].includes(this.currentUser.roleId)) {
      obj.action = (this.currentUser?.roleId == 11) ? 'ReviewApplicationBI' : (this.currentUser?.roleId == 12) ? 'ReviewApplicationDI' : 'ReviewApplicationAR'

    }
    if ([36, 37, 38].includes(this.currentUser.roleId)) {
      obj.action = (this.currentUser?.roleId == 36) ? 'ReviewApplicationDH' : (this.currentUser?.roleId == 37) ? 'ReviewApplicationBO' : 'ReviewApplicationRegistrar'
      // ReviewApplicationRegistrar - 38
    }
    this.byLawsService.byLawsVerificationProcess(obj).subscribe((res: any) => {
      if (res?.status == 200) {
        this.toastService.showSuccess(res?.message)
        // this.router.navigate([`/bylaws`]);
        if ([36, 37, 38].includes(this.currentUser.roleId)) {
          this.getbylawsProgressDetail(data, 'ByLawsProgress2006');
        } else {
          this.getbylawsProgressDetail(data, 'ByLawsProgress');
        }

      }

    }, (res) => {

      if (res.status != 200) {

        this.toastService.showError('Something went wrong')
      }
    })
  }
  formatBylaws(text: string | null | undefined): string {
    if (!text) return 'NA';

    return text
      .split('|')
      .map(x => x.trim())
      .filter(x => x)
      .join(', ');
  }

  addAmendments() {
    if (this.societyDetails?.iSocietyId === 1) {
      this.router.navigate(['bylaws2006'], { relativeTo: this.route });
    } else {
      this.router.navigate(['addbylaws'], { relativeTo: this.route });
    }
  }
  editAmendments(row?: any) {
    if (this.societyDetails?.iSocietyId === 1) {
      this.router.navigate(['bylaws2006'], { relativeTo: this.route });

      this.router.navigate(
        ['bylaws2006'],
        {
          relativeTo: this.route,
          queryParams: { byLawsId: row?.iByLawsId }
        }
      )
    } else {
      // this.router.navigate(['addbylaws'], { relativeTo: this.route });
      // this.router.navigate(['addbylaws'], { relativeTo: this.route });

      this.router.navigate(
        ['addbylaws'],
        {
          relativeTo: this.route,
          queryParams: { byLawsId: row?.iByLawsId }
        }
      )
    }
  }

  /** Edit only for draft (IsCompleted==7). Hide after submit (e.g. Pending). */
  canEditAmendment(row: any): boolean {
    if (!row) {
      return false;
    }
    const completed = Number(row?.IsCompleted ?? row?.isCompleted);
    return completed === 7;
  }
  toggle(check: number) {
    this.applicationModel = check
  }
  // addAmendments() {
  //   this.router.navigate(['/bylaws/addbylaws'])
  // }
  downloadDocument(path: any) {
    if (path) {
      const fileUrl = this.byLawsService.downloadPath(path);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank'; // Open in a new tab
      link.download = fileUrl.split('/').pop() || 'downloaded-file'; // Extract filename from URL
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      this.toastService.showError('Document path is not available');
    }
  }

  downloadFile(fileName: string) {
    let fileUrl:any = '';
    if(fileName.includes('/')){
       fileUrl = this.configService.getFileUrl() + fileName;
    }else{
       fileUrl = this.configService.getFileUrl() + 'ByLaws/' + fileName;
    }

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank'; // Optional: specify a file name
    link.click();
  }
  print(id: any) {
    let content: any = document.getElementById(id)
    html2canvas(content).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('portrait', 'pt', 'a4');
      pdf.addImage(imgData, 'PNG', 20, 20, 550, 750);
      pdf.save('Bylaws_Order.pdf');
    });

  }

  viewMore(event: any) {
    this.ExpendeText = event
    this.openModal('readMoreModal')
  }
  hideViewMore() {
    this.ExpendeText = ''
    this.hideModal('readMoreModal')
  }
  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }



  /** True when Status Details timeline is for 2006 Act (DH/BO/Registrar). */
  private progressIs2006 = false;

  /** Long View Remark: collapsed by default; Read more expands. */
  remarkPreviewExpanded = false;
  private readonly remarkPreviewCollapseChars = 280;

  isLongRemarkText(text: any): boolean {
    return String(text || '').trim().length > this.remarkPreviewCollapseChars;
  }

  toggleRemarkPreviewExpand(): void {
    this.remarkPreviewExpanded = !this.remarkPreviewExpanded;
  }

  /**
   * Society User View Remark:
   * 1968 → Block Inspector Send Back only
   * 2006 → Dealing Hand Send Back only
   */
  canShowSocietyBiViewRemark(item: any): boolean {
    if (Number(this.currentUser?.roleId) !== 9) {
      return false;
    }
    if (this.progressIs2006) {
      return this.isSocietyDhSendBackProgressItem(item);
    }
    return this.isSocietyBiSendBackProgressItem(item);
  }

  private timelineRemarkRowKey(item: any): string {
    return [
      String(item?.RoleName || ''),
      String(item?.AuditStatus || ''),
      String(item?.dCreatedDate || '')
    ].join('|');
  }

  /** Compare calendar dates only (ignore time). */
  private isSameCalendarDate(a: any, b: any): boolean {
    if (a == null || b == null) {
      return false;
    }
    const da = new Date(a);
    const db = new Date(b);
    if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) {
      return false;
    }
    return (
      da.getFullYear() === db.getFullYear() &&
      da.getMonth() === db.getMonth() &&
      da.getDate() === db.getDate()
    );
  }

  /** True if dash sRemarks is real officer text (not system "Application Sent Back..." message). */
  private isOfficerDashRemark(text: any): boolean {
    const t = String(text || '').trim();
    if (!t) {
      return false;
    }
    const lower = t.toLowerCase();
    return !(
      lower.startsWith('application sent back') ||
      lower.startsWith('application sendback') ||
      lower.startsWith('application move') ||
      lower.startsWith('bylaws') ||
      lower.startsWith('bye-laws')
    );
  }

  /** Toggle remark for a timeline row into the right panel (yellow for Society User). */
  viewTimelineRemark(item: any): void {
    const roleName = String(item?.RoleName || '');
    const role = roleName.toLowerCase();
    const rowKey = this.timelineRemarkRowKey(item);

    // Same timeline row again → close
    if (
      this.selectedRemarkDetails &&
      this.selectedRemarkDetails._key === rowKey
    ) {
      this.closeTimelineRemark();
      return;
    }

    this.remarkPreviewExpanded = false;

    if (role.includes('block inspector')) {
      // Prefer per-row dash remark (new Send Back stores officer text in TByLawsDash.sRemarks)
      const dashRemark = String(item?.sRemarks ?? item?.SRemarks ?? '').trim();
      if (this.isOfficerDashRemark(dashRemark)) {
        this.selectedRemarkDetails = {
          remark: dashRemark,
          remarkDate: item?.dCreatedDate,
          FilePath: null,
          roleName,
          _key: rowKey
        };
        return;
      }

      // GetRemark has only ONE latest BI remark — show it only when timeline date matches remark date
      const latestRemark = String(this.remarkList?.sBlockInspectorRemark || '').trim();
      const dateMatches = this.isSameCalendarDate(
        item?.dCreatedDate,
        this.remarkList?.dBlockInspectorRemarkDate
      );
      if (dateMatches && latestRemark) {
        this.selectedRemarkDetails = {
          remark: latestRemark,
          remarkDate: this.remarkList.dBlockInspectorRemarkDate,
          FilePath: this.remarkList.sBlockInspectorDocument,
          roleName,
          _key: rowKey
        };
        return;
      }

      // Older Send Back with no stored remark for that date
      this.selectedRemarkDetails = {
        remark: 'not remark added',
        remarkDate: item?.dCreatedDate,
        FilePath: null,
        roleName,
        _key: rowKey
      };
      return;
    }
    // 2006 Society: Dealing Hand Send Back remark
    if (role.includes('dealing hand') || role.includes('dealing head')) {
      const dashRemark = String(item?.sRemarks ?? item?.SRemarks ?? '').trim();
      if (this.isOfficerDashRemark(dashRemark)) {
        this.selectedRemarkDetails = {
          remark: dashRemark,
          remarkDate: item?.dCreatedDate,
          FilePath: null,
          roleName,
          _key: rowKey
        };
        return;
      }
      const latestRemark = String(this.remarkList?.sDealingHeadRemark || '').trim();
      const dateMatches = this.isSameCalendarDate(
        item?.dCreatedDate,
        this.remarkList?.dDealingHeadRemarkDate
      );
      if (dateMatches && latestRemark) {
        this.selectedRemarkDetails = {
          remark: latestRemark,
          remarkDate: this.remarkList.dDealingHeadRemarkDate,
          FilePath: this.remarkList.sDealingHeadDocument,
          roleName,
          _key: rowKey
        };
        return;
      }
      this.selectedRemarkDetails = {
        remark: 'not remark added',
        remarkDate: item?.dCreatedDate,
        FilePath: null,
        roleName,
        _key: rowKey
      };
      return;
    }
    if (role.includes('district')) {
      this.selectedRemarkDetails = {
        remark: this.remarkList?.sDistrictAuditOfficerRemark,
        remarkDate: this.remarkList?.dDistrictAuditOfficerRemarkDate,
        FilePath: this.remarkList?.sDistrictAuditOfficerDocument,
        roleName,
        _key: rowKey
      };
      return;
    }
    if (role.includes('assistant registrar')) {
      this.selectedRemarkDetails = {
        remark: this.remarkList?.sAssistantRegistrarRemark,
        remarkDate: this.remarkList?.dAssistantRegistrarRemarkDate,
        FilePath: this.remarkList?.sAssistantRegistrarDocument,
        roleName,
        _key: rowKey
      };
      return;
    }
    this.toastService.showError('Remark not available for this entry.');
  }

  /** Hide the View Remark preview panel (Society / X button). */
  closeTimelineRemark(): void {
    this.selectedRemarkDetails = null;
    this.remarkPreviewExpanded = false;
  }

  changeRole(event: any) {

    let val = event.target.value

    if (val == 11) {
      this.remarkList?.IsBlockInspectorRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sBlockInspectorRemark,
        'remarkDate': this.remarkList?.dBlockInspectorRemarkDate,
        'FilePath': this.remarkList?.sBlockInspectorDocument

      })

      // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sBlockInspectorRemark)
    } else if (val == 19) {
      this.remarkList?.sDistrictAuditOfficerRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sDistrictAuditOfficerRemark,
        'remarkDate': this.remarkList?.dDistrictAuditOfficerRemarkDate,
        'FilePath': this.remarkList?.sDistrictAuditOfficerDocument

      })
    } else if (val == 13) {
      this.remarkList?.IsAssistantRegistrarRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sAssistantRegistrarRemark,
        'remarkDate': this.remarkList?.dAssistantRegistrarRemarkDate,
        'FilePath': this.remarkList?.sAssistantRegistrarDocument

      })
      // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sAssistantRegistrarRemark)
    } else if (val == 36) {
      this.remarkList?.IsDealingHeadRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sDealingHeadRemark,
        'remarkDate': this.remarkList?.dDealingHeadRemarkDate,
        'FilePath': this.remarkList?.sDealingHeadDocument

      })

      // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sBlockInspectorRemark)
    } else if (val == 37) {
      this.remarkList?.IsBranchOfficerRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sBranchOfficerRemark,
        'remarkDate': this.remarkList?.dBranchOfficerRemarkDate,
        'FilePath': this.remarkList?.sBranchOfficerDocument

      })
    } else {
      this.remarkList?.IsRegistrarRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sRegistrarRemark,
        'remarkDate': this.remarkList?.dRegistrarRemarkDate,
        'FilePath': this.remarkList?.sRegistrarDocument

      })
      // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sAssistantRegistrarRemark)
    }

    // this.selectedRemarkDetails && this.openAmendmentsModal()

  }
  getBindRoles(action: any) {
    this.byLawsService.getBindRoles(action).subscribe(response => {
      if (response?.status === 200 && response?.data) {

        this.roles = response.data.filter((i: any) => i.RoleId == 10 || i.RoleId == 36);

      }

    })
  }
  getbylawsProgressDetail(data: any, action: any) {
    if (this.currentUser.roleId == 9) {
      data.iSocietyDetailsId = this.societyDetails?.iSocietyDetailsId
    }
    this.progressIs2006 = action === 'ByLawsProgress2006';
    this.byLawsService.getByLawsProgressDetail(data, action).subscribe((res: any) => {
      if (res?.status == 200 && res?.data && res?.data.length > 0) {
        const rows = res.data || [];
        if (Number(this.currentUser?.roleId) === 9) {
          if (this.progressIs2006) {
            // --- OLD (2006 Society: DH Send Back only → other DH/BO/Reg steps hidden) ---
            // const filtered = rows.filter((item: any) =>
            //   this.isSocietyDhSendBackProgressItem(item)
            // );
            // this.bylawsProgress = this.dedupeSocietyBiSendBackByDate(filtered);

            // Society User 2006: full status track (Received / Move Forward / Accept DH–BO–Reg).
            // View Remark still only on DH Send Back (canShowSocietyBiViewRemark).
            const otherSteps = rows.filter(
              (item: any) => !this.isSocietyDhSendBackProgressItem(item)
            );
            const sendBackSteps = this.dedupeSocietyBiSendBackByDate(
              rows.filter((item: any) => this.isSocietyDhSendBackProgressItem(item))
            );
            this.bylawsProgress = [...otherSteps, ...sendBackSteps].sort(
              (a, b) =>
                new Date(b?.dCreatedDate).getTime() -
                new Date(a?.dCreatedDate).getTime()
            );
          } else {
            // --- OLD (1968 Society: BI Send Back only → blank when no Send Back) ---
            // const filtered = rows.filter((item: any) =>
            //   this.isSocietyBiSendBackProgressItem(item)
            // );
            // this.bylawsProgress = this.dedupeSocietyBiSendBackByDate(filtered);

            // Society User 1968: full status track (Received / Move Forward DI–BI / …)
            // View Remark still only on BI Send Back (canShowSocietyBiViewRemark)
            const otherSteps = rows.filter(
              (item: any) => !this.isSocietyBiSendBackProgressItem(item)
            );
            const sendBackSteps = this.dedupeSocietyBiSendBackByDate(
              rows.filter((item: any) => this.isSocietyBiSendBackProgressItem(item))
            );
            this.bylawsProgress = [...otherSteps, ...sendBackSteps].sort(
              (a, b) =>
                new Date(b?.dCreatedDate).getTime() -
                new Date(a?.dCreatedDate).getTime()
            );
          }
        } else {
          this.bylawsProgress = rows;
        }
      } else {
        this.bylawsProgress = [];
      }

    }, (res) => {

      if (res.status != 200) {

        this.toastService.showError('Something went wrong')
      }
    })
  }

  /** Society User 1968: BI Send Back row (View Remark + dedupe). Full track uses all rows. */
  private isSocietyBiSendBackProgressItem(item: any): boolean {
    const status = String(item?.AuditStatus || '').toLowerCase();
    const role = String(item?.RoleName || '').toLowerCase();
    return status.includes('send back') && role.includes('block inspector');
  }

  /** Society User 2006: DH Send Back row (View Remark + dedupe). Full track uses all rows. */
  private isSocietyDhSendBackProgressItem(item: any): boolean {
    const status = String(item?.AuditStatus || '').toLowerCase();
    const role = String(item?.RoleName || '').toLowerCase();
    return (
      status.includes('send back') &&
      (role.includes('dealing hand') || role.includes('dealing head'))
    );
  }

  /**
   * Old SendBack UPDATEd every BI dash row to status=7 with same date → many identical
   * "Application Send Back - dd/MM/yyyy" lines. Keep one row per calendar date.
   */
  private dedupeSocietyBiSendBackByDate(items: any[]): any[] {
    const byDay = new Map<string, any>();
    for (const item of items || []) {
      const d = item?.dCreatedDate ? new Date(item.dCreatedDate) : null;
      const key =
        d && !Number.isNaN(d.getTime())
          ? `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
          : String(item?.dCreatedDate || Math.random());
      const existing = byDay.get(key);
      if (!existing) {
        byDay.set(key, item);
        continue;
      }
      // Prefer row with real officer remark text over system message / empty
      const nextRemark = String(item?.sRemarks ?? item?.SRemarks ?? '').trim();
      const prevRemark = String(
        existing?.sRemarks ?? existing?.SRemarks ?? ''
      ).trim();
      const nextBetter =
        this.isOfficerDashRemark(nextRemark) &&
        !this.isOfficerDashRemark(prevRemark);
      const nextNewer =
        new Date(item?.dCreatedDate).getTime() >
        new Date(existing?.dCreatedDate).getTime();
      if (nextBetter || (!this.isOfficerDashRemark(prevRemark) && nextNewer)) {
        byDay.set(key, item);
      }
    }
    return Array.from(byDay.values()).sort(
      (a, b) =>
        new Date(b?.dCreatedDate).getTime() - new Date(a?.dCreatedDate).getTime()
    );
  }
  closeModel() {
    this.aplicationDetailList = []
    this.aplicationDetailList.selectedRow = null
    this.applicationModel = 1
    this.updateStatusForm.reset();
    this.selectedRemarkDetails = null;
    this.remarkList = []

  }

  getUserRemarks(iByLawsId: any, action: any) {

    this.byLawsService.getRemarks(iByLawsId, action).subscribe(res => {
      if (res?.data && res?.data.length > 0) {
        this.remarkList = res?.data[0]

      } else {
        this.remarkList = []

      }


    },
      (error: any) => {
        this.toastService.showError(error.message);
      }
    );
  }
  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        resolve(reader.result as string);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(blob);
    });
  }
  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.'); // Find the last dot
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : ''; // Get substring after the last dot
  }
  async onFileSelected(event: any, fileInput: string) {
    const file = event.target.files[0];

    if (file) {
      let fileName = file.name;
      let fileExtension = this.getFileExtension(file.name);

      if (
        fileExtension !== 'jpg' &&
        fileExtension !== 'jpeg' &&
        fileExtension !== 'png' &&
        fileExtension !== 'pdf'
      ) {
        this.toastService.showError(
          'Invalid file type. Allowed types: jpg, jpeg, png, pdf.'
        );
        event.target.value = '';
        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB
      if (fileSizeInMB > 2) {
        this.toastService.showError(
          'File size should be less then or equal 2 MB'
        ); // Display error if file size exceeds 2MB
        event.target.value = '';
        return;
      }


      let blob = new Blob([file], { type: file.type })
      let content = await this.blobToBase64(blob);
      let obj = {
        path: fileName,
        content: content
      }

      this.updateStatusForm.get(fileInput)?.setValue(obj);
    } else {
      this.updateStatusForm.get(fileInput)?.setValue('');
    }

  }
  closeRemarkModel() {
    this.selectedRemarkDetails = ''
    this.hideModal('remarkDetails')

  }
  printDate: Date = new Date();
  formatDatepay(date: Date): string {
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }
  getAmendmentName(id: any): string {
    const amendment = this.AmendmentType.find((a: any) => a.id == id);
    return amendment ? amendment.name : '';
  }
  printForm() {

    const doc = new jsPDF('p', 'mm', 'a4');

    const primary: [number, number, number] = [41, 128, 185];

    let startY = 15;

    const pageHeight = doc.internal.pageSize.height;

    const checkPageBreak = (extra: number = 10) => {
      if (startY + extra > pageHeight - 10) {
        doc.addPage();
        startY = 15;
      }
    };

    doc.setFont('helvetica', 'bold');
    doc.text('Amendments Application Details', 14, startY);

    startY += 10;

    doc.setFontSize(10);

    doc.setFont('helvetica', 'bold');
    doc.text(`Reference ID:`, 14, startY);

    doc.setFont('helvetica', 'normal');
    doc.text(`${this.aplicationDetailList?.selectedRow?.iByLawsId || '-'}`, 45, startY);

    startY += 6;

    const rawDate = this.printDate || new Date();
    const date = new Date(rawDate).toLocaleDateString('en-GB');

    doc.setFont('helvetica', 'bold');
    doc.text(`Printed On:`, 14, startY);

    doc.setFont('helvetica', 'normal');
    doc.text(`${date}`, 45, startY);

    startY += 10;

    // ================= SECTION TITLE =================
    const addSectionTitle = (title: string) => {
      checkPageBreak(10);
      doc.setFontSize(11);
      doc.setTextColor(0, 0, 0);
      doc.text(title, 14, startY);
      startY += 6;
    };

    // ================= AUTHORIZED PERSON =================
    addSectionTitle('Details of Authorized Person');

    autoTable(doc, {
      startY,
      head: [['Authorized Person Details', '']],

      body: [
        ['Name', this.aplicationDetailList?.user?.firstName || '-'],
        ['Address', this.aplicationDetailList?.user?.address || '-'],
        ['Mobile', this.aplicationDetailList?.user?.mobile || '-'],
        ['Email', this.aplicationDetailList?.user?.email || '-']
      ],
      theme: 'grid',
      styles: {
        fontSize: 9,
        lineColor: primary,
        lineWidth: 0.2
      },
      headStyles: {
        fillColor: primary,
        textColor: 255
      }
    });

    startY = (doc as any).lastAutoTable.finalY + 10;

    // ================= AMENDMENTS =================
    addSectionTitle('Amendments Proposed In');

    const amendmentRows = (this.amendmentsList || []).map((item: any, i: number) => [
      i + 1,
      this.getAmendmentName(item.amendmentType),
      item.resolutionNo,
      new Date(item.resolutionDate).toLocaleDateString('en-GB')

    ]);

    autoTable(doc, {
      startY,
      head: [['#', 'Amendment', 'Resolution No', 'Date']],
      body: amendmentRows,
      theme: 'grid',
      styles: {
        fontSize: 9,
        lineColor: primary,
        lineWidth: 0.2
      },
      headStyles: {
        fillColor: primary,
        textColor: 255
      }
    });

    startY = (doc as any).lastAutoTable.finalY + 10;

    // ================= BYLAWS GROUP (FIXED OVERFLOW) =================
    // TASK: hide Proposed section when empty — undo if manager asks to revert
    this.groupedBylaws.forEach((group: any, index: number) => {
      if (!this.groupHasProposed(group)) {
        return;
      }
      const letter = String.fromCharCode(97 + index);
      addSectionTitle(
        `${letter}. Amendments in ${this.getAmendmentName(group.amendmentType)}`
      );
      const rows = group.bylaws
        .filter((item: any) => this.hasProposedContent(item.proposedChange))
        .map((item: any) => [
        item.existingDetails || '-',
        item.proposedChange || '-'
      ]);

      autoTable(doc, {
        startY,
        head: [['Existing', 'Proposed']],
        body: rows,
        theme: 'grid',

        styles: {
          fontSize: 8,
          lineColor: primary,
          lineWidth: 0.2,
          overflow: 'linebreak',
          cellPadding: 2
        },

        columnStyles: {
          0: { cellWidth: 90 },
          1: { cellWidth: 90 },
        },

        headStyles: {
          fillColor: primary,
          textColor: 255
        }
      });

      startY = (doc as any).lastAutoTable.finalY + 10;

    });

    // ================= GENERAL BODY MEMBERS =================
    if (this.societyMemberList?.length) {

      addSectionTitle('General Body Members');

      autoTable(doc, {
        startY,

        head: [[
          '#',
          'Name',
          'Age',
          'Gender',
          'Father/Husband',
          'Occupation',
          'Fee / Challan',
          'Type of Member',
          'Address',
          'Designation',
          'Document'
        ]],

        body: this.societyMemberList.map((item: any, i: number) => {

          const parentName =
            item.sGender === 'Male'
              ? item.sFatherName
              : (item.sGender === 'Female' && item.sMaritalStatus === 'Married')
                ? item.sMemHusName
                : item.sFatherName;

          return [
            i + 1,
            item.sMemName || '-',
            item.sMemAge || '-',
            item.sGender || '-',
            parentName || '-',
            item.sOccupation || '-',
            item.sMemShipFee || 'N/A',
            item.sMembershiptypename || '-',
            `${item.sAdd1 || ''} ${item.sAdd2 || ''}`.trim(),
            item.sMemberDesignation || '-',
            'Document Attached'
          ];
        }),

        theme: 'grid',

        styles: {
          fontSize: 8,
          lineColor: primary,
          lineWidth: 0.2
        },

        headStyles: {
          fillColor: primary,
          textColor: 255
        }

      });

      startY = (doc as any).lastAutoTable.finalY + 10;
    }
    // ================= GOVERNING BODY =================
    if (this.filteredGoverningMembers?.length) {

      addSectionTitle('Governing Body Members');

      autoTable(doc, {
        startY,
        head: [['#', 'Name', 'Designation', 'Gender', 'Occupation']],
        body: this.filteredGoverningMembers.map((item: any, i: number) => [
          i + 1,
          item.sMemName,
          item.sMemberDesignation,
          item.sGender,
          item.sOccupation
        ]),
        theme: 'grid',
        styles: {
          fontSize: 8,
          lineColor: primary,
          lineWidth: 0.2
        },
        headStyles: {
          fillColor: primary,
          textColor: 255
        }
      });

      startY = (doc as any).lastAutoTable.finalY + 10;
    }

    // ================= DOCUMENTS =================
    if (this.Uploadedkeys?.length) {

      addSectionTitle('Requisite Documents');

      autoTable(doc, {
        startY,
        head: [['#', 'Document', 'Status']],
        body: this.Uploadedkeys.map((key: any, i: number) => [
          i + 1,
          this.formatLabel(key),
          'Document Attached'
        ]),
        theme: 'grid',
        styles: {
          fontSize: 9,
          lineColor: primary,
          lineWidth: 0.2
        },
        headStyles: {
          fillColor: primary,
          textColor: 255
        }
      });
    }

    // ================= SAVE =================
    doc.save('Amendments_Full_Report.pdf');
  }
  payNow(row: any) {

    Swal.fire({
      title: 'Payment Gateway',
      text: 'Please do not refresh or close the page while proceeding with payment.',
      icon: 'info',
      confirmButtonText: 'Continue'
    }).then((result) => {

      if (result.isConfirmed) {

        const payload = {
          deptID: "320",
          deptRefNo: "HP12345",
          totalAmount: row?.FeeAmount,
          tenderBy: this.societyDetails?.sSocietyName,
          appRefNo: "TXN" + Date.now(),

          head1: "0425-00-800-01",
          amount1: row?.FeeAmount,
          ddo: "CTO00-072",
          serviceCode: "COS",
          periodFrom: this.formatDatepay(new Date()),
          periodTo: this.formatDatepay(new Date()),


          referenceId: row?.iByLawsId ? row?.iByLawsId.toString() : '',
          iScoietyDetailId: this.societyDetails?.iSocietyDetailsId,
          moduleType: "BYELAWS",

          returnUrl: "https://coophpapi.atishay.com/api/payment/PaymentResponse"
        };
        this.paymentService.initiatePayment(payload).subscribe((res: any) => {

          const form = document.createElement('form');
          form.method = res.method;
          form.action = res.action;

          Object.keys(res.fields).forEach(key => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = res.fields[key];
            form.appendChild(input);
          });

          document.body.appendChild(form);
          form.submit();
        });

      }

    });

  }
  closeModal(){
   this.updateStatusForm = this.fb.group({
      role: [''],
      statusFile: [''],
      status: ['', Validators.required],
      remark: ['', Validators.required],
      // checkboxes: this.fb.array([], [this.allCheckboxesRequired()])

    })
   this.selectedRemarkDetails='';
   this.applicationModel==1
}
}
